export default __webpack_public_path__ + "static/media/supper_apps_background_l2.2d8ffc87.jpg";